import "./Cardqrdownloadapp.css";

const Cardqrdownloadapp = () => {
  return (
    <div className="cardqrdownloadapp">
      <div className="divcard33">
        <img
          className="qrcirclesdd2d3900svg-icon"
          loading="eager"
          alt=""
          src="/qrcirclesdd2d3900svg.svg"
        />
        <img
          className="image-icon"
          loading="eager"
          alt=""
          src="/image@2x.png"
        />
        <div className="frame-easyandfast-wrapper">
          <div className="frame-easyandfast">
            <div className="frame-parent20">
              <div className="easy-and-fast-wrapper">
                <b className="easy-and-fast3">Easy and fast</b>
              </div>
              <img
                className="qr-arrow4e8b9d4asvg-icon"
                loading="eager"
                alt=""
                src="/qrarrow4e8b9d4asvg.svg"
              />
            </div>
            <h1 className="heading-112">Download App</h1>
            <button className="button30">
              <b className="download">Download</b>
            </button>
          </div>
        </div>
        <img
          className="qrcurves963bc650svg-icon"
          loading="eager"
          alt=""
          src="/qrcurves963bc650svg.svg"
        />
      </div>
    </div>
  );
};

export default Cardqrdownloadapp;
